import { useEffect, useMemo } from 'react';
var KeyPressEvents;
(function (KeyPressEvents) {
    KeyPressEvents["keydown"] = "keydown";
    KeyPressEvents["keyup"] = "keyup";
})(KeyPressEvents || (KeyPressEvents = {}));
/**
 * React Hook to help instantiate input configuration and reduce code repetition
 */
export default function useInputConfig(config, opts) {
    const formattedCallbacks = useMemo(() => {
        const keyMapCallback = {};
        for (const keyconfig of config) {
            for (const key of keyconfig.keyCodes) {
                // @ts-ignore
                keyMapCallback[key] = keyconfig.callback;
            }
        }
        return (keyPressedValues) => {
            keyMapCallback[keyPressedValues.keyPressed]?.(keyPressedValues.keyDir, keyPressedValues.keyPressed);
        };
    }, [config]);
    const onKeyDown = useMemo(() => {
        return (e) => formattedCallbacks({ keyPressed: e.code, keyDir: 'down' });
    }, [formattedCallbacks]);
    const onKeyUp = useMemo(() => {
        return (e) => formattedCallbacks({ keyPressed: e.code, keyDir: 'up' });
    }, [formattedCallbacks]);
    useEffect(() => {
        const useKeyDown = !opts || opts?.watchEvents.includes('keydown');
        const useKeyUp = opts?.watchEvents.includes('keyup');
        useKeyDown && window.addEventListener('keydown', onKeyDown);
        useKeyUp && window.addEventListener('keyup', onKeyUp);
        // Remove event listeners on cleanup
        return () => {
            useKeyDown && window.removeEventListener('keydown', onKeyDown);
            useKeyUp && window.removeEventListener('keyup', onKeyUp);
        };
    }, [formattedCallbacks]);
}
//# sourceMappingURL=useInputConfig.js.map